export function normalizeRole(role) {
  return String(role || '').trim().toLowerCase() === 'admin' ? 'admin' : 'user';
}

export function isAdmin(user) {
  return normalizeRole(user?.role) === 'admin';
}
